import React from "react";
import styled from "styled-components";
import { colors } from "./colors/color";

export type ButtonDivProps = {
    hoverBackgroundColor?: string,
    style?: React.CSSProperties,
    children?: React.ReactNode
    onClick?: () => void,
};
export function ButtonDiv(props: ButtonDivProps): JSX.Element {

    function handleClick() {
        if (props.onClick) {
            props.onClick();
        }
    }

    function handleKeyDown(event: React.KeyboardEvent<HTMLDivElement>) {
        if (props.onClick && (event.key === 'Enter' || event.key === ' ')) {
            props.onClick();
        }
    }

    return (
        <StyledButton role="button" tabIndex={0} hoverBackgroundColor={props.hoverBackgroundColor || colors.buttonDiv.defaultHoverBackgroundColor}
            onClick={handleClick} 
            onKeyDown={handleKeyDown}
            style={props.style}>
            {props.children}
        </StyledButton>
    );
}
    
const StyledButton = styled.div<{ hoverBackgroundColor: string }>`
    width: 100%;
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
    font-family: "Noto Sans", sans-serif;
    font-size:16px;
    font-weight:300;
    border-radius:4px;
    text-align: left;

    &:hover {
        background-color: ${props => props.hoverBackgroundColor};
    }
`;
